import { SnackbarContext } from "../context/snackbar/SnackbarContext";
import { useContext } from "react";

export const useSnackbar = () => useContext(SnackbarContext);
